<!--
~ Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
~ This information is confidential and proprietary to GM Global Technology
~ Operations LLC and may not be used, modified, copied or distributed.
-->

<div class="container showcase">
	<div class="row showcase-header">
		<div class="col-xs-3 col-sm-4">
			<button class="pull-left action-button left-action back-button" *ngIf="showBackButton" routerLink='/home'>
				<span class="visible-xs">Back</span>
				<i class="fa fa-angle-left hidden-xs" aria-hidden="true"></i>
			</button>
		</div>
		<div class="col-xs-6 col-sm-4 showcase-title">
			{{title}}
		</div>
		<div class="col-xs-3 col-sm-4">
			<ng-content select=".showcase-header-right"></ng-content>
		</div>
	</div>

	<div class="row showcase-body" [ngClass]="{'blur-background': blurBackground}">
		<div class="col-xs-12">
			<ng-content select=".showcase-body"></ng-content>
		</div>
	</div>

</div>
